import axios from '@axios'
import moment from 'moment'

export default {
    namespaced: true,
    state: {
        empresas: [],
        personas: [],
        allPersonas: [],
        empresa: {
            nombre: '',
            tipo_identificacion: { cod_tipo_identificacion: null, descripcion: null },
            tipo_empresa: { cod_tipo_empresa: null, descripcion: null },
            tipo_compania: { cod_tipo_compania: null, descripcion: null },
            tipo_situacion_legal: { cod_tipo_situacion_legal: null, descripcion: null },
            pais: { id_pais: null, name: null },
        },
        ubicacion: {
            pais: { id: null, name: null },
            provincia: { id: null, name: null },
            ciudad: { id: null, name: null },
        },
        contacto: {},
        actividadEconomica: {},
        capital: {},
        paises: [],
        provincias: [],
        ciudades: [],
        administradores: [],
        bienes: [],
        accionistas: [],
        accionistasActuales: [],
        kardexAccionistas: [],
        dondeSoyAccionista: [],
        cedulaAccionistas: [],
        tiposDocumentos: [],
        subtiposDocumentos: [],
        subtiposDocumentosXtipo: [],
        documentos: [],
        tipoDocumento: [],
        organigramaEmpresa: {},
        administradoresActuales: [],
        administradoresAnteriores: [],
        empresasSinPadre: [],
        empresasEnOrganigrama: [],
        accionistasOrganigrama: [],
        accionistasOrganigramaAnt: [],
        tiposEmpresa: [],
        tiposSituacionLegal: [],
        opcionesTipoCompania: [],
        infoAdministradorAct: [],
        infoAdministradorAnt: [],
        infoAccionistaAct: [],
        infoAccionistaAnt: [],
        permisosOrganigrama: [],
        usuariosLegal: [],
        transacciones: [],
        cargosAdministrador: [],
        tiposIdentificacion: [],
        opcionesTipoInversion: [],
    },
    getters: {
        getEmpresas(state) {
            return state.empresas
        },
        getPersonas(state) {
            return state.personas
        },
        getAllPersonas(state) {
            return state.allPersonas
        },
        getEmpresa(state) {
            return state.empresa
        },
        getUbicacion(state) {
            return state.ubicacion
        },
        getContacto(state) {
            return state.contacto
        },
        getActividadEconomica(state) {
            return state.actividadEconomica
        },
        getCapital(state) {
            return state.capital
        },
        getPaises(state) {
            return state.paises
        },
        getProvincias(state) {
            return state.provincias
        },
        getCiudades(state) {
            return state.ciudades
        },
        getAdministradores(state) {
            return state.administradores
        },
        getBienes(state) {
            return state.bienes
        },
        getAccionistas(state) {
            return state.accionistas
        },
        getAccionistasActuales(state) {
            return state.accionistasActuales
        },
        getKardexAccionistas(state) {
            return state.kardexAccionistas
        },
        getDondeSoyAccionista(state) {
            return state.dondeSoyAccionista
        },
        getCedulaAccionistas(state) {
            return state.cedulaAccionistas
        },
        getTiposDocumentos(state) {
            return state.tiposDocumentos
        },
        getDocumentos(state) {
            return state.documentos
        },
        getTipoDocumento(state) {
            return state.tipoDocumento
        },
        getSubTiposDocumentos(state) {
            return state.subtiposDocumentos
        },
        getSubTiposDocumentosXtipo(state) {
            return state.subtiposDocumentosXtipo
        },
        getOrganigramaEmpresa(state) {
            return state.organigramaEmpresa
        },
        getAdministradoresActuales(state) {
            return state.administradoresActuales
        },
        getAdministradoresAnteriores(state) {
            return state.administradoresAnteriores
        },
        getEmpresasSinPadre(state) {
            return state.empresasSinPadre
        },
        getEmpresasEnOrganigrama(state) {
            return state.empresasEnOrganigrama
        },
        getAccionistasOrganigrama(state) {
            return state.accionistasOrganigrama
        },
        getAccionistasOrganigramaAnt(state) {
            return state.accionistasOrganigramaAnt
        },
        getTiposEmpresa(state) {
            return state.tiposEmpresa
        },
        getTiposSituacionLegal(state) {
            return state.tiposSituacionLegal
        },
        getTiposCompania(state) {
            return state.opcionesTipoCompania
        },
        getInfoAdministradorAct(state) {
            return state.infoAdministradorAct
        },
        getInfoAdministradorAnt(state) {
            return state.infoAdministradorAnt
        },
        getInfoAccionistaAct(state) {
            return state.infoAccionistaAct
        },
        getInfoAccionistaAnt(state) {
            return state.infoAccionistaAnt
        },
        getPermisosOrganigrama(state) {
            return state.permisosOrganigrama
        },
        getUsuariosLegal(state) {
            return state.usuariosLegal
        },
        getTransacciones(state) {
            return state.transacciones
        },
        getCargosAdministrador(state) {
            return state.cargosAdministrador
        },
        getTiposIdentificacion(state) {
            return state.tiposIdentificacion
        },
        getTiposInversion(state) {
            return state.opcionesTipoInversion
        },
    },
    mutations: {
        SET_EMPRESAS(state, empresas) {
            state.empresas = empresas
        },
        SET_PERSONAS(state, personas) {
            state.personas = personas
        },
        SET_ALL_PERSONAS(state, allPersonas) {
            state.allPersonas = allPersonas
        },
        SET_EMPRESA(state, empresa) {
            state.empresa = empresa
        },
        SET_UBICACION(state, ubicacion) {
            state.ubicacion = ubicacion
        },
        SET_CONTACTO(state, contacto) {
            state.contacto = contacto
        },
        SET_ACTIVIDADECONOMICA(state, actividadEconomica) {
            state.actividadEconomica = actividadEconomica
        },
        SET_CAPITAL(state, capital) {
            state.capital = capital
        },
        SET_PAISES(state, paises) {
            state.paises = paises
        },
        SET_PROVINCIAS(state, provincias) {
            state.provincias = provincias
        },
        SET_CIUDADES(state, ciudades) {
            state.ciudades = ciudades
        },
        SET_ADMINISTRADORES(state, administradores) {
            state.administradores = administradores
        },
        SET_BIENES(state, bienes) {
            state.bienes = bienes
        },
        SET_ACCIONISTAS(state, accionistas) {
            state.accionistas = accionistas
        },
        SET_ACCIONISTAS_ACTUALES(state, accionistasActuales) {
            state.accionistasActuales = accionistasActuales
        },
        SET_KARDEX_ACCIONISTAS(state, kardexAccionistas) {
            state.kardexAccionistas = kardexAccionistas
        },
        SET_DONDESOYACCIONISTA(state, dondeSoyAccionista) {
            state.dondeSoyAccionista = dondeSoyAccionista
        },
        SET_CEDULA_ACCIONISTAS(state, cedulaAccionistas) {
            state.cedulaAccionistas = cedulaAccionistas
        },
        SET_TIPOS_DOCUMENTOS(state, tiposDocumentos) {
            state.tiposDocumentos = tiposDocumentos
        },
        SET_DOCUMENTOS(state, documentos) {
            state.documentos = documentos
        },
        SET_TIPODOCUMENTO(state, tipoDocumento) {
            state.tipoDocumento = tipoDocumento
        },
        SET_SUBTIPOS_DOCUMENTOS(state, subtiposDocumentos) {
            state.subtiposDocumentos = subtiposDocumentos
        },
        SET_SUBTIPOS_DOCUMENTOS_TIPO(state, subtiposDocumentosXtipo) {
            state.subtiposDocumentosXtipo = subtiposDocumentosXtipo
        },
        SET_ORGANIGRAMA_EMPRESA(state, organigramaEmpresa) {
            state.organigramaEmpresa = organigramaEmpresa
        },
        SET_ADMINISTRADORES_ACTUALES(state, administradoresActuales) {
            state.administradoresActuales = administradoresActuales
        },
        SET_ADMINISTRADORES_ANTERIORES(state, administradoresAnteriores) {
            state.administradoresAnteriores = administradoresAnteriores
        },
        SET_EMPRESAS_SIN_PADRE(state, empresasSinPadre) {
            state.empresasSinPadre = empresasSinPadre
        },
        SET_EMPRESAS_EN_ORGANIGRAMA(state, empresasEnOrganigrama) {
            state.empresasEnOrganigrama = empresasEnOrganigrama
        },
        SET_ACCIONISTAS_ORGANIGRAMA(state, accionistasOrganigrama) {
            state.accionistasOrganigrama = accionistasOrganigrama
        },
        SET_ACCIONISTAS_ORGANIGRAMA_ANT(state, accionistasOrganigramaAnt) {
            state.accionistasOrganigramaAnt = accionistasOrganigramaAnt
        },
        SET_TIPOS_EMPRESA(state, tiposEmpresa) {
            state.tiposEmpresa = tiposEmpresa
        },
        SET_INFO_ADMIN_ACT(state, infoAdministradorAct) {
            state.infoAdministradorAct = infoAdministradorAct
        },
        SET_INFO_ADMIN_ANT(state, infoAdministradorAnt) {
            state.infoAdministradorAnt = infoAdministradorAnt
        },
        SET_INFO_ACC_ACT(state, infoAccionistaAct) {
            state.infoAccionistaAct = infoAccionistaAct
        },
        SET_INFO_ACC_ANT(state, infoAccionistaAnt) {
            state.infoAccionistaAnt = infoAccionistaAnt
        },
        SET_PERMISOS_ORGANIGRAMA(state, permisosOrganigrama) {
            state.permisosOrganigrama = permisosOrganigrama
        },
        SET_USUARIOS_LEGAL(state, usuariosLegal) {
            state.usuariosLegal = usuariosLegal
        },
        SET_TRANSACCIONES(state, transacciones) {
            state.transacciones = transacciones
        },
        SET_CARGOS_ADMINISTRADOR(state, cargosAdministrador) {
            state.cargosAdministrador = cargosAdministrador
        },
        SET_TIPOS_IDENTIFICACION(state, tiposIdentificacion) {
            state.tiposIdentificacion = tiposIdentificacion
        },
        SET_TIPOS_SITUACION_LEGAL(state, tiposSituacionLegal) {
            state.tiposSituacionLegal = tiposSituacionLegal
        },
        SET_TIPOS_COMPANIA(state, opcionesTipoCompania) {
            state.opcionesTipoCompania = opcionesTipoCompania
        },
        SET_TIPOS_INVERSION(state, opcionesTipoInversion) {
            state.opcionesTipoInversion = opcionesTipoInversion
        },
    },
    actions: {
        fetchEmpresas({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/empresas')
                    .then(response => {
                        commit('SET_EMPRESAS', response.data)
                        resolve(1)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEmpresa({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/empresa', { params: data })
                    .then(response => {
                        commit('SET_EMPRESA', {
                            cod_empresa: response.data.cod_empresa,
                            identificacion: response.data.identificacion,
                            cod_tipo_identificacion: response.data.cod_tipo_identificacion,
                            expediente: response.data.expediente,
                            nombre: response.data.nombre,
                            nombre_comercial: response.data.nombre_comercial,
                            fecha_constitucion: response.data.fecha_constitucion,
                            // nacionalidad: response.data.nacionalidad,
                            plazo_social: response.data.plazo_social,
                            cod_tipo_compania: response.data.cod_tipo_compania,
                            oficina_control: response.data.oficina_control,
                            cod_tipo_empresa: response.data.cod_tipo_empresa,
                            id_pais: response.data.id_pais,
                            cod_tipo_situacion_legal: response.data.cod_tipo_situacion_legal,
                            internacional: response.data.internacional,
                            tipo_identificacion: response.data.tipo_identificacion,
                            tipo_compania: response.data.tipo_compania,
                            tipo_empresa: response.data.tipo_empresa,
                            tipo_situacion_legal: response.data.tipo_situacion_legal,
                            pais: response.data.pais,
                            fecha_constitucion_format: moment(response.data.fecha_constitucion)
                                .locale('es')
                                .format('LL'),
                            fecha_plazo_social:
                                response.data.fecha_plazo_social === 0
                                    ? 'N/A'
                                    : moment(response.data.fecha_plazo_social).locale('es').format('LL'),
                        })
                        commit('SET_UBICACION', response.data.ubicacion)
                        // commit('SET_CONTACTO', response.data.contacto);
                        commit('SET_ACTIVIDADECONOMICA', response.data.actividad_economica)
                        commit('SET_CAPITAL', response.data.capital)
                        resolve(response.data.ubicacion)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPersonas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/personas', { params: data })
                    .then(response => {
                        commit('SET_PERSONAS', response.data.data)
                        resolve({
                            from: response.data.from,
                            last_page: response.data.last_page,
                            per_page: response.data.per_page,
                            prev_page_url: response.data.prev_page_url,
                            to: response.data.to,
                            total: response.data.total,
                        })
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAllPersonas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/allPersonas', { params: data })
                    .then(response => {
                        commit('SET_ALL_PERSONAS', response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchUbicacion({ commit }, id) {
            return new Promise(resolve => {
                axios
                    .get(`/api/auth/legal/ubicacion/${id}`)
                    .then(response => {
                        commit('SET_UBICACION', response.data[0])
                        resolve()
                    })
                    .catch(error => {
                        console.error(error)
                    })
            })
        },

        fetchContacto({ commit }, id) {
            return new Promise(resolve => {
                axios
                    .get(`/api/auth/legal/contacto/${id}`)
                    .then(response => {
                        commit('SET_CONTACTO', response.data[0])
                        resolve()
                    })
                    .catch(error => {
                        console.error(error)
                    })
            })
        },

        fetchActividadEconomica({ commit }, id) {
            return new Promise(resolve => {
                axios
                    .get(`/api/auth/legal/actividad_economica/${id}`)
                    .then(response => {
                        commit('SET_ACTIVIDADECONOMICA', response.data[0])
                        resolve()
                    })
                    .catch(error => {
                        console.error(error)
                    })
            })
        },

        fetchCapital({ commit }, id) {
            return new Promise(resolve => {
                axios
                    .get(`/api/auth/legal/capital/${id}`)
                    .then(response => {
                        commit('SET_CAPITAL', response.data[0])
                        resolve()
                    })
                    .catch(error => {
                        console.error(error)
                    })
            })
        },

        fetchPaises({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/paises')
                    .then(response => {
                        commit('SET_PAISES', response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchProvincias({ commit }, id) {
            return new Promise(() => {
                axios
                    .get(`/api/auth/legal/provincias/${id}`)
                    .then(response => {
                        commit('SET_PROVINCIAS', response.data)
                    })
                    .catch(error => {
                        console.error(error)
                    })
            })
        },

        fetchCiudades({ commit }, id) {
            return new Promise(() => {
                axios
                    .get(`/api/auth/legal/ciudades/${id}`)
                    .then(response => {
                        commit('SET_CIUDADES', response.data)
                    })
                    .catch(error => {
                        console.error(error)
                    })
            })
        },

        fetchAdministradores({ commit }, data) {
            commit('SET_ADMINISTRADORES', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/administradores', { params: data })
                    .then(response => {
                        commit('SET_ADMINISTRADORES', response.data)
                        resolve(1)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchBienes({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/legal/bienes/${id}`)
                    .then(response => {
                        commit('SET_BIENES', response.data)
                        resolve()
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAccionistas({ commit }, data) {
            commit('SET_ACCIONISTAS', [])
            // commit('SET_ACCIONISTAS_ACTUALES', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/accionistas', { params: data })
                    .then(response => {
                        const cedulas = response.data.filter(accionista => accionista.tipo_accionista === 'P')
                        const actuales = response.data.filter(accionista => accionista.actual === 1)
                        const total = actuales.reduce((anterior, actual) => {
                            return anterior + actual.capital
                        }, 0)
                        actuales.map(e => {
                            e.check = true
                            e.accionDividido = null
                            e.accionNueva = null
                            e.titulo = null
                            e.porcentaje_accion = Number.parseFloat((e.capital * 100) / total).toFixed(4)
                            return e
                        })
                        commit('SET_ACCIONISTAS', response.data)
                        // commit('SET_ACCIONISTAS_ACTUALES', actuales)
                        commit('SET_CEDULA_ACCIONISTAS', cedulas)
                        resolve(actuales)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAccionistasActuales({ commit }, data) {
            commit('SET_ACCIONISTAS_ACTUALES', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/accionistasActuales', { params: data })
                    .then(response => {
                        const actuales = response.data
                        const total = actuales.reduce((anterior, actual) => {
                            return anterior + actual.sum_capital
                        }, 0)
                        actuales.map(e => {
                            e.porcentaje_accion = Number.parseFloat((e.sum_capital * 100) / total).toFixed(4)
                            return e
                        })
                        commit('SET_ACCIONISTAS_ACTUALES', actuales)
                        resolve(1)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchKardexAccionistas({ commit }, data) {
            commit('SET_KARDEX_ACCIONISTAS', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/kardexAccionistas', { params: data })
                    .then(response => {
                        commit('SET_KARDEX_ACCIONISTAS', response.data)
                        resolve(1)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDondeSoyAccionista({ commit }, data) {
            commit('SET_DONDESOYACCIONISTA', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/dondeSoyAccionista/', { params: data })
                    .then(response => {
                        commit('SET_DONDESOYACCIONISTA', response.data)
                        resolve(1)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTiposDocumentos({ commit }) {
            return new Promise(() => {
                axios
                    .get(`/api/auth/legal/tiposDocumentos`)
                    .then(response => {
                        commit('SET_TIPOS_DOCUMENTOS', response.data)
                    })
                    .catch(error => {
                        console.error(error)
                    })
            })
        },

        fetchSubTiposDocumentos({ commit }) {
            return new Promise(() => {
                axios
                    .get(`/api/auth/legal/subtiposDocumentos`)
                    .then(response => {
                        commit('SET_SUBTIPOS_DOCUMENTOS', response.data)
                    })
                    .catch(error => {
                        console.error(error)
                    })
            })
        },

        fetchSubTiposDocumentosXtipo({ commit }, tipo_documento) {
            return new Promise(() => {
                axios
                    .get(`/api/auth/legal/subtiposDocumentosXtipo/${tipo_documento}`)
                    .then(response => {
                        commit('SET_SUBTIPOS_DOCUMENTOS_TIPO', response.data)
                    })
                    .catch(error => {
                        console.error(error)
                    })
            })
        },

        fetchDocumentos({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/almacenDocumentos/documentos')
                    .then(response => {
                        commit('SET_DOCUMENTOS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTipoDocumento({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/almacenDocumentos/tipoDocumento')
                    .then(response => {
                        commit('SET_TIPODOCUMENTO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDescargarDocumentos({ commit }, data) {
            return new Promise((resolve, reject) => {
                var link = '/api/auth/almacenDocumentos/descargarDocumento'
                axios({ method: 'post', url: link, responseType: 'blob', data })
                    .then(response => {
                        commit('SET_DescargarDocumentos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAgregarEmpresa(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/agregarEmpresa', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAgregarBien(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/agregarBien', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postEditarEmpresa(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/editarEmpresa', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postEditarUbicacion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/editarUbicacion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postEditarContactos(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/editarContactos', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarActividadEconomica(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/editarActividadEconomica', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarCapital(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/editarCapital', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAgregarTipoDocumento(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/agregarTipoDocumento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postSubirDocumento(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/subirDocumento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postTransferirDocumento(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/almacenDocumentos/transferirDocumento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postCrearTipoDocumento(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/almacenDocumentos/crearTipoDocumento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postEditarTipoDocumento(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/editarTipoDocumento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postEliminarTipoDocumento(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/eliminarTipoDocumento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAgregarSubtipoDocumento(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/agregarSubtipoDocumento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postEditarAdministrador(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/editarAdministrador', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postEditarAccionista(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/editarAccionistaSocio', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchOrganigramaEmpresa({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/organigramaEmpresa')
                    .then(response => {
                        commit('SET_ORGANIGRAMA_EMPRESA', response.data)
                        resolve(1)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAdministradoresActAnt({ commit }, data) {
            commit('SET_ADMINISTRADORES_ACTUALES', [])
            commit('SET_ADMINISTRADORES_ANTERIORES', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/administradoresActAnt', { params: data })
                    .then(response => {
                        commit('SET_ADMINISTRADORES_ACTUALES', response.data.actuales)
                        commit('SET_ADMINISTRADORES_ANTERIORES', response.data.anteriores)
                        resolve(1)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEmpresasSinPadre({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/empresasSinPadre', { params: data })
                    .then(response => {
                        commit('SET_EMPRESAS_SIN_PADRE', response.data)
                        resolve(1)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEmpresasEnOrganigrama({ commit }) {
            // commit('SET_EMPRESAS_EN_ORGANIGRAMA', []);
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/empresasEnOrganigrama')
                    .then(response => {
                        commit('SET_EMPRESAS_EN_ORGANIGRAMA', response.data)
                        resolve(1)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postElimiarDependencia(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/eliminarDependencia', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAgregarDependencia(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/agregarDependencia', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postMoverEmpresa(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/moverEmpresa', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postObtenerRegistroMercantil(_a, data) {
            return new Promise((resolve, reject) => {
                // axios.post('/api/auth/legal/obtenerRegistroMercantil', data)
                // var link = '/api/auth/almacenDocumentos/descargarDocumento'
                axios({
                    method: 'post',
                    url: '/api/auth/legal/obtenerRegistroMercantil',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAccionistasOrganigrama({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/accionistasOrganigrama', { params: data })
                    .then(response => {
                        const total = response.data.actuales.reduce((anterior, actual) => {
                            return anterior + actual.capital
                        }, 0)
                        response.data.actuales.forEach(e => {
                            e.porcentaje_accion = Number.parseFloat((e.capital * 100) / total).toFixed(4)
                        })
                        commit('SET_ACCIONISTAS_ORGANIGRAMA', response.data.actuales)
                        commit('SET_ACCIONISTAS_ORGANIGRAMA_ANT', response.data.anteriores)
                        resolve(total)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchPersona(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/persona', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAgregarPersona(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/agregarPersona', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postEditarPersona(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/editarPersona', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAgregarAccionista(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/agregarAccionista', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTiposEmpresa({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/tiposEmpresa')
                    .then(response => {
                        commit('SET_TIPOS_EMPRESA', response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAgregarAdministrador(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/agregarAdministrador', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDondeSoy({ commit }, data) {
            commit('SET_INFO_ADMIN_ACT', [])
            commit('SET_INFO_ADMIN_ANT', [])
            commit('SET_INFO_ACC_ACT', [])
            commit('SET_INFO_ACC_ANT', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/dondeSoy', { params: data })
                    .then(response => {
                        commit('SET_INFO_ADMIN_ACT', response.data.soyAdminAct)
                        commit('SET_INFO_ADMIN_ANT', response.data.soyAdminAnt)
                        commit('SET_INFO_ACC_ACT', response.data.soyAccAct)
                        commit('SET_INFO_ACC_ANT', response.data.soyAccAnt)
                        resolve(1)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPermisosOrganigrama({ commit }) {
            commit('SET_PERMISOS_ORGANIGRAMA', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/permisosOrganigrama')
                    .then(response => {
                        commit('SET_PERMISOS_ORGANIGRAMA', response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchUsuariosLegal({ commit }) {
            commit('SET_USUARIOS_LEGAL', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/usuariosLegal')
                    .then(response => {
                        resolve(1)
                        commit('SET_USUARIOS_LEGAL', response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAgregarPermisoOrganigrama(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/agregarPermisoOrganigrama', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postEditarPermisoOrganigrama(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/editarPermisoOrganigrama', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postEliminarPermisoOrganigrama(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/eliminarPermisoOrganigrama', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTransacciones({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/transacciones')
                    .then(response => {
                        commit('SET_TRANSACCIONES', response.data)
                        resolve(1)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCargosAdministrador({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/cargosAdministrador')
                    .then(response => {
                        commit('SET_CARGOS_ADMINISTRADOR', response.data)
                        resolve(1)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postIngresarAumento(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/legal/ingresarAumento', data)
                    .then(() => {
                        resolve(1)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTiposIdentificacion({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/tiposIdentificacion')
                    .then(response => {
                        commit('SET_TIPOS_IDENTIFICACION', response.data)
                        // resolve(response);
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTiposSituacionLegal({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/tiposSituacionLegal')
                    .then(response => {
                        commit('SET_TIPOS_SITUACION_LEGAL', response.data)
                        // resolve(response);
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTiposCompania({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/tiposCompania')
                    .then(response => {
                        commit('SET_TIPOS_COMPANIA', response.data)
                        // resolve(response);
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTiposInversion({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/legal/tiposInversion')
                    .then(response => {
                        commit('SET_TIPOS_INVERSION', response.data)
                        // resolve(response);
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        putEliminarAdministrador(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/api/auth/legal/eliminarAdministrador', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
